<template>
  <div id="app">
    <div>
      <b-navbar toggleable="lg" type="dark">

        <router-link to="/" exact><img class="elixir-ee_brand" src="./assets/elixir_ee.png" alt="ELIXIR Estonia"></router-link>

        <b-navbar-brand to="/" exact exact-active-class="active" @click="page = 'grid'">
          eQTL Catalogue Browser
        </b-navbar-brand>

        <b-navbar-nav class="ml-auto">
        <b-nav-item to="/about" exact exact-active-class="active" right @click="page = 'about'">About</b-nav-item>
        <b-nav-item to="/all-comments" v-show="isAuthenticated" exact exact-active-class="active" right @click="page = 'all-comments'">All Comments</b-nav-item>
        <b-nav-item v-show="isAuthenticated" @click="handleLogout" right>Logout</b-nav-item>

        </b-navbar-nav>
      </b-navbar>
    </div>


    <router-view></router-view>

    <hr>

<!--    <div>The ELIXIR Estonia eQTL Browser respects our users' privacy and therefore we do not store user queries.</div>-->

    <p class="text-muted text-center">
      The ELIXIR Estonia eQTL Browser respects our users' privacy and therefore we do not store user queries. <br />
      We use cookies to analyze site traffic, including the number of visitors and the pages they visited within the website.
    </p>

    <div class="copy">
      <a href="https://elixir.ut.ee/" class="image">
        <img src="https://biit.cs.ut.ee/gprofiler/elixir-ee_logo.png" id="elixir_logo" alt="ELIXIR logo">
      </a>
      <a href="https://www.ut.ee/en" class="image">
        <img alt="Emblem of the University of Tartu" src="https://inkuzmin.github.io/logos/assets/unitartu.svg" width="100">
      </a>
    </div>
  </div>
</template>

<script>
import DataTable from './components/DataTable.vue'
import HelloWorld from './components/HelloWorld.vue'
import AllComments from './components/AllComments.vue'
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  data() {
    return {
      page: 'grid'
    }
  },
  components: {
    DataTable, HelloWorld, AllComments
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  methods: {
    ...mapActions(['logout']),
    handleLogout() {
      this.logout();
      // this.$router.push('/');
      if (this.$route.path !== '/') {
          this.$router.push('/');
        }
    }
  }

}
</script>

<style lang="scss">

$theme-colors: ( "primary": coral );


@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

.btn.btn-primary {
  color: white;
}

.btn:active {
  opacity: 0.7;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app nav {
  background-color: coral;
  margin-bottom: 20px;
}

#app .navbar-brand img.logo {
  width: 200px;
}

.version {
  top:9px;
}

.navbar-brand {
  background-image: url('assets/logo.png');
  background-size: auto 100%;
  margin-left: -15px;
}



// ag-grid
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";



//.ag-font-style {
//  user-select: initial;
//  -moz-user-select: text;
//  -ms-user-select: text;
//  -webkit-user-select: text;
//}

.ag-cell {
  line-height: 18px !important;
  text-align: left;
  //font-size: 12px;
  //padding-left: 8px !important;
  //padding-right: 8px !important;
}

.ag-cell-focus {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

// footer
.copy {
  text-align: center;
  padding-bottom: 15px;
}

.image {
  margin: 0 5px;
}

#elixir_logo {
  height: 80px;
}

.elixir-ee_brand {
  height: 65px;
}



</style>

